var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rocket_svg__clip0_45451_69129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.883 7.117l-5.256 5.256m.567-3.815L1.62 7.95a.372.372 0 01-.178-.624L3.49 5.278a.743.743 0 01.52-.218l2.308-.02M9.225 2.4a16.663 16.663 0 014.376 4.376m-6.16 5.03l.608 2.575a.372.372 0 00.625.178l2.047-2.048a.743.743 0 00.218-.52l.02-2.308m3.083-4.115l.6-2.89a1.115 1.115 0 00-1.318-1.32l-2.89.601a4.455 4.455 0 00-2.247 1.213L5.816 5.542a5.952 5.952 0 00-1.68 3.344l-.008.054a2.584 2.584 0 002.931 2.93l.055-.007a5.948 5.948 0 003.344-1.68l2.37-2.37a4.456 4.456 0 001.214-2.246z",
    stroke: "#E95832",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rocket_svg__clip0_45451_69129"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/rocket.1d8e8ca4.svg";
export { SvgRocket as ReactComponent };